// src/utils/allergyState.js
//
// The three honest states of "what is this patient allergic to", from the
// doctor's patient-detail response (top-level `allergies`) — the same rule the
// consultation page uses (services/visitApi.js getPatientSnapshot):
//   text        the allergy text (shown in an amber tile)
//   none        field present but null / blank: "No allergies recorded"
//   unavailable field absent, or the lookup failed: never shown as "none"

export const ALLERGY_NONE_TEXT = 'No allergies recorded';
export const ALLERGY_UNAVAILABLE_TEXT = 'Allergies not available — check the patient record';

/** @param {object|null|undefined} detail the GET /doctor/patients/{id} body (null when the lookup failed) */
export function allergyState(detail) {
  if (!detail || typeof detail !== 'object' || !('allergies' in detail)) {
    return { kind: 'unavailable', text: ALLERGY_UNAVAILABLE_TEXT };
  }
  const raw = detail.allergies;
  const text = typeof raw === 'string' ? raw.trim() : '';
  return text ? { kind: 'text', text } : { kind: 'none', text: ALLERGY_NONE_TEXT };
}
